import {
  apiRequestDelete,
  apiRequestGet,
  apiRequestPost,
  apiRequestPut,
} from 'mastodon/api';

export interface ApiDraftJSON {
  id: string;
  text: string;
  spoiler_text: string;
  visibility: string | null;
  sensitive: boolean;
  language: string | null;
  in_reply_to_id: string | null;
  created_at: string;
  updated_at: string;
}

export type ApiDraftParams = Pick<
  ApiDraftJSON,
  | 'text'
  | 'spoiler_text'
  | 'visibility'
  | 'sensitive'
  | 'language'
  | 'in_reply_to_id'
>;

export const apiGetDrafts = () => apiRequestGet<ApiDraftJSON[]>('v1/drafts');

export const apiCreateDraft = (params: ApiDraftParams) =>
  apiRequestPost<ApiDraftJSON>('v1/drafts', params);

export const apiUpdateDraft = (id: string, params: ApiDraftParams) =>
  apiRequestPut<ApiDraftJSON>(`v1/drafts/${id}`, params);

export const apiDeleteDraft = (id: string) =>
  apiRequestDelete(`v1/drafts/${id}`);
